import Swal from 'sweetalert2';

export const warning = (title: string, text?: string, showCancelButton = false) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: showCancelButton,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
    });
};

export const success = (title: string, text?: string) => {
    return Swal.fire(title, text, 'success');
};

export const toastSuccess = (title: string, text?: string) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'success',
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
    });
};

export const toastError = (title: string, text?: string) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'error',
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
    });
};
